import { render } from "./Misconduct_Referee.vue?vue&type=template&id=2ce8eff1&scoped=true"
import script from "./Misconduct_Referee.vue?vue&type=script&lang=js"
export * from "./Misconduct_Referee.vue?vue&type=script&lang=js"

import "./Misconduct_Referee.vue?vue&type=style&index=0&id=2ce8eff1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce8eff1"]])

export default __exports__